import {Select, SelectProps} from "antd";
import {CalenderIcon} from "./CalenderIcon";
import React, {useEffect, useRef, useState} from "react";
import {calculateMonths, parseDateRange} from "../../../reducers/util";
import styles from './PeriodSelector.module.scss'
import {DownArrowIcon} from "./DownArrowIcon";
import _ from "lodash";
import {useAppSelector} from "../../../hooks";
import {selectValues} from "../../../reducers/settings";
import {dateRangeValues} from "../../query-builder/components/DateRange";
import {CohortDataset} from "../../../containers/HealthcareUsageReport/types/CohortQuery";

export type PeriodSelectorProps = {
    value: SelectProps<any>["value"]
    dataset: CohortDataset
    onChange: SelectProps<any>["onChange"]
    disabled?: boolean
    fromDate?: string
    testId: string
}

function options(monthYearVal: object) {
    return Object.entries(monthYearVal).map(([k, v]) => <Select.Option key={v} value={v}>{k}</Select.Option>)
}

export function toOptionsFiltered(from: string | undefined, monthYearVal: object) {
    if (!_.isNil(from)) {
        const [month, year] = from.split("/")
        const m = parseInt(month, 10)
        const y = parseInt(year, 10)
        return Object
            .entries(monthYearVal)
            .filter(([, v]) => {
                const [_month, _year] = v.split("/")
                const _m = parseInt(_month, 10)
                const _y = parseInt(_year, 10)
                return _y > y || (_y === y && _m >= m)
            })
            .map(([k, v]) => <Select.Option key={v} value={v}>{k}</Select.Option>)
    } else {
        return options(monthYearVal)
    }
}

const PeriodSelector = ({value, dataset, onChange, disabled, fromDate, testId}: PeriodSelectorProps) => {
    const settings = useAppSelector(selectValues)
    const datasetDateRange = dateRangeValues(dataset.toString() === 'HES' ? 'IP' : 'OPCRD', settings) as string
    const { monthYearVal } = calculateMonths(parseDateRange(datasetDateRange))
    const selectRef = useRef<HTMLElement>(null)
    const downArrowRef = useRef<HTMLDivElement>(null)
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (isOpen && !_.isNil(selectRef?.current)) {
            selectRef.current.focus()
        }
    }, [selectRef, isOpen])

    return <div className={styles.periodSelectorWrapper} data-testid={testId}>
            <Select
                open={isOpen}
                ref={selectRef}
                className={styles.periodSelector}
                disabled={disabled === true}
                suffixIcon={<CalenderIcon/>}
                showSearch
                optionFilterProp="children"
                value={value}
                filterOption={(input, option) =>
                    option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onClear={() => {
                    if (!isOpen) {
                        setIsOpen(true)
                    }
                }}
                onSearch={() => {
                    if (!isOpen) {
                        setIsOpen(true)
                    }
                }}
                onBlur={(event) => {
                    if(event.relatedTarget !== downArrowRef.current) {
                        setIsOpen(false)
                    }
                }}
                onChange={(value, option) => {
                    if (onChange !== undefined) {
                        onChange(value, option)
                    }
                    setIsOpen(false)
                }}
            >
                {fromDate === undefined ? options(monthYearVal) : toOptionsFiltered(fromDate, monthYearVal)}
            </Select>
            <div
                tabIndex={-1}
                ref={downArrowRef}
                className={styles.downArrow}
                onClick={() => {
                    setIsOpen(!isOpen)
                }}
            >
                <DownArrowIcon/>
            </div>
        </div>

}

export default PeriodSelector